import React, { useState } from "react";

const Shared = () => {
  return (
    <div className="container">
      <h2>Guest Feedback</h2>
    </div>
  );
};

export default Shared;
